export enum PostAssignmentPromptType {
  gradeExplanation = 'grade_explanation',
  transcriptSearch = 'transcript_search',
}

// convenience data types as enums are a nightmare to work dynamically with in JS
export const PostAssignmentPromptTypeMap = {
  grade_explanation: PostAssignmentPromptType.gradeExplanation,
  transcript_search: PostAssignmentPromptType.transcriptSearch,
}

export const PostAssignmentPromptTypeReverseMap = {
  [PostAssignmentPromptType.gradeExplanation]: 'grade_explanation',
  [PostAssignmentPromptType.transcriptSearch]: 'transcript_search',
}

export const PostAssignmentPromptTypeList = [
  PostAssignmentPromptType.gradeExplanation,
  PostAssignmentPromptType.transcriptSearch,
]

export const PostAssignmentPromptTypeNames = Object.keys(
  PostAssignmentPromptTypeMap
)
